import { connect } from "react-redux";

import RouteStatistics from "./RouteStatistics";

import { changeRoute } from "../../store/actions";

const mapStateToProps = state => ({
    metrics: state.metrics 
});

const mapDispatchToProps = dispatch => ({
  onRouteChange: () => dispatch(changeRoute()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RouteStatistics);
